import React from 'react';
import { LinkData } from '../types';

interface Props {
  config: Record<string, any>;
  links: LinkData[];
}

export const InlineReadingCallout: React.FC<Props> = ({ config, links }) => {
  // Use correct field names matching types.ts definition
  const {
    style = 'left-border',
    showIcon = true,
    calloutHeading = 'Related Reading', // Correct field name from types.ts
    maxLinks = 3,
    linkDisplay = 'list',
  } = config;

  // Get visual style
  const getStyleProps = (): React.CSSProperties => {
    switch (style) {
      case 'bordered':
        return { border: '1px solid #e2e8f0', padding: '1rem' };
      case 'background':
        return { backgroundColor: '#f8fafc', padding: '1rem' };
      case 'left-border':
      default:
        return { borderLeft: '4px solid #2db77a', backgroundColor: '#f0fdf4', padding: '1rem' };
    }
  };

  // Limit links based on maxLinks config
  const visibleLinks = links.slice(0, maxLinks);
  if (visibleLinks.length === 0) return null;

  const isInlineDisplay = linkDisplay !== 'list';

  return (
    <div style={{ borderRadius: '8px', fontFamily: 'system-ui', ...getStyleProps() }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '0.5rem' }}>
        {showIcon && <span>📚</span>}
        <span style={{ fontSize: '0.85rem', color: '#166534', fontWeight: 600 }}>{calloutHeading}</span>
      </div>
      <ul
        style={{
          listStyle: 'none',
          margin: 0,
          padding: 0,
          ...(isInlineDisplay ? { display: 'flex', gap: '0.5rem 1rem', flexWrap: 'wrap' } : {}),
        }}
      >
        {visibleLinks.map((link, i) => (
          <li key={i} style={{ padding: isInlineDisplay ? 0 : '0.25rem 0' }}>
            <a href={link.url} style={{ color: '#2db77a', textDecoration: 'none', fontSize: '0.9rem' }}>
              {link.title || link.anchorText || link.url}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
